import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum NumberInputVariants {
  Disabled = 'disabled',
  Ready = 'ready',
  Filled = 'filled',
}

const numberInputParts = [
  'container',
  'input',
  'inputRightElement',
  'text',
] as const

const helpers = createMultiStyleConfigHelpers(numberInputParts)

export const NumberInputStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      paddingBottom: '1rem',
      gap: '1.25rem',
    },
    input: {
      display: 'flex',
      flex: 1,
      color: 'fg.default',
      ...textStyles[textStyleKeys.H3],
      letterSpacing: '-0.24px',
      _placeholder: {
        color: 'border.default',
        textSTyle: textStyleKeys.H3,
        textAlign: 'center',
      },
      paddingRight: 0,
    },
    inputRightElement: {
      height: 'full',
      marginRight: '0.75rem',
      opacity: 0,
      transition: 'opacity 0.15s ease-in-out',
      cursor: 'default',
      backgroundColor: 'transparent',
      _focusVisible: {
        opacity: '100%',
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
  },
  variants: {
    [NumberInputVariants.Disabled]: {
      container: {
        borderColor: 'border.muted',
      },
      input: {
        _placeholder: {
          color: 'border.muted',
          ...textStyles[textStyleKeys.H3],
        },
      },
    },
    [NumberInputVariants.Ready]: {},
    [NumberInputVariants.Filled]: {
      inputRightElement: {
        opacity: '100%',
        cursor: 'pointer',
      },
    },
  },
})

export const useNumberInputStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(NumberInputStyle, props) as MultiStyleType<
    typeof numberInputParts
  >
}
